import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/ClientProfiles/";

export function getProfile(ClientId) {
  return apiUtils
    .get(`${baseUrl}${ClientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getGoodForInstall(ClientId, VehicleId) {
  return apiUtils
    .get(`${baseUrl}GoodForInstall?clientId=${ClientId}&vehicleId=${VehicleId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getInstalledClientVehicles(ClientId) {
  return apiUtils
    .get(`${baseUrl}InstalledClientVehicles?clientId=${ClientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getClickAndGoClientVehicles(ClientId) {
  return apiUtils
    .get(`${baseUrl}ClickAndGoClientVehicles?clientId=${ClientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getIsClickAndGoClient(ClientId) {
  return apiUtils
    .get(`${baseUrl}IsClickAndGoClient?clientId=${ClientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateProfile(ClientId, params) {
  return apiUtils
    .put(`${baseUrl}UpdateProfile`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateOrCopyClientProfile(params) {
  return apiUtils
    .put(`${baseUrl}UpdateOrCopyClientProfile`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function updateClientEmail(params) {
  return apiUtils
    .put(`${baseUrl}UpdateClientEmail`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
